(function () {
  const WRAP_SELECTOR = '.pd-payicons';
  const ATC_SELECTORS = [
    'button[name="add"]',
    'button[type="submit"][name="add"]',
    'form[action*="/cart/add"] button[type="submit"]',
    '.product-form button[type="submit"]',
    '.product-form__submit',
    '.product-form__buttons button[type="submit"]',
    '.add-to-cart',
    '.btn--add-to-cart'
  ];

  function findAddToCartButton(root) {
    for (const sel of ATC_SELECTORS) {
      const el = root.querySelector(sel);
      if (el) return el;
    }
    return null;
  }

  function syncWidth() {
    const wrap = document.querySelector(WRAP_SELECTOR);
    if (!wrap) return;

    const root =
      wrap.closest('form') ||
      wrap.closest('.product') ||
      wrap.closest('.product__info-container') ||
      document;

    const atc = findAddToCartButton(root);
    if (!atc) {
      wrap.style.width = '100%';
      wrap.style.maxWidth = '100%';
      wrap.style.marginLeft = 'auto';
      wrap.style.marginRight = 'auto';
      return;
    }

    const rect = atc.getBoundingClientRect();
    if (!rect.width) return;

    wrap.style.width = rect.width + 'px';
    wrap.style.maxWidth = '100%';
    wrap.style.marginLeft = 'auto';
    wrap.style.marginRight = 'auto';
  }

  function init() {
    syncWidth();

    window.addEventListener('resize', syncWidth);

    const mo = new MutationObserver(syncWidth);
    mo.observe(document.body, { childList: true, subtree: true });

    if ('ResizeObserver' in window) {
      const ro = new ResizeObserver(syncWidth);
      ro.observe(document.documentElement);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
